/**
 * TrendModa — Sosyal Kanıt (GERÇEK veri / Google Apps Script + Sheets)
 *
 * - Ürün sayfası görüntülenmesini ve sepete-ekleme olaylarını anonim loglar.
 * - Ürün kartlarındaki "X inceliyor / X sepetinde" rozetlerini GERÇEK sayılarla doldurur.
 * - Veri yoksa (0) ilgili rozet/metrik gizlenir — asla uydurma sayı göstermez.
 *
 * Yapılandırma: window.TM_SOCIAL_PROOF = { enabled, endpoint } (theme.liquid'de set edilir)
 * Gizlilik: yalnızca anonim oturum kimliği + ürün id'si gönderilir, KVKK kapsamında PII yok.
 */
(function () {
  'use strict';

  var CFG = window.TM_SOCIAL_PROOF || {};
  if (!CFG.enabled || !CFG.endpoint) return;
  var ENDPOINT = CFG.endpoint;

  var VIEW_THROTTLE_MS = 30 * 60 * 1000; // aynı oturum/ürün için 30 dk'da bir view logla
  var COUNTS_CACHE_MS = 60 * 1000;       // sayıları 60 sn cache'le
  var recentAtc = {};                    // çift sayımı engelle

  // --- Anonim oturum kimliği ---
  function sessionId() {
    try {
      var k = 'tm_sp_sid', v = localStorage.getItem(k);
      if (!v) {
        v = (Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
        localStorage.setItem(k, v);
      }
      return v;
    } catch (_) { return 'anon'; }
  }

  // --- Olay gönder (yaz, yanıt okunmaz → no-cors) ---
  function logEvent(type, productId) {
    if (!productId) return;
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify({
          action: 'event', type: type,
          productId: String(productId), sessionId: sessionId(), ts: Date.now()
        })
      }).catch(function () {});
    } catch (_) {}
  }

  function logViewOncePerWindow(productId) {
    try {
      var k = 'tm_sp_v_' + productId, last = parseInt(localStorage.getItem(k) || '0', 10);
      if (Date.now() - last < VIEW_THROTTLE_MS) return;
      localStorage.setItem(k, String(Date.now()));
    } catch (_) {}
    logEvent('view', productId);
  }

  function logAtc(productId) {
    if (!productId) return;
    if (recentAtc[productId] && Date.now() - recentAtc[productId] < 5000) return;
    recentAtc[productId] = Date.now();
    logEvent('atc', productId);
  }

  // --- Rozetleri doldur ---
  function collectIds() {
    var ids = {};
    document.querySelectorAll('conversion-urgency[data-product-id], [data-tm-sp][data-product-id]').forEach(function (el) {
      var id = el.getAttribute('data-product-id');
      if (id) ids[id] = true;
    });
    return Object.keys(ids);
  }

  // Kompakt çip (ürün kartında "Kapıda Ödeme" yanında) — küçük, dikkat çekici
  function applyChip(el, v, c) {
    var label = '';
    if (v >= 1) label = v + ' kişi bakıyor';
    else if (c >= 1) label = c + ' kişi sepetinde';
    if (!label) { el.hidden = true; el.innerHTML = ''; return; }
    el.innerHTML = '<span class="tm-sp-dot" aria-hidden="true"></span>' + label;
    el.hidden = false;
  }

  function applyCounts(el, v, c) {
    var viewSlides = [], cartSlides = [];
    el.querySelectorAll('.tm-conversion-slide').forEach(function (s) {
      if (s.querySelector('.view-count')) viewSlides.push(s);
      if (s.querySelector('.cart-count')) cartSlides.push(s);
    });
    el.querySelectorAll('.view-count').forEach(function (x) { x.textContent = v; });
    el.querySelectorAll('.cart-count').forEach(function (x) { x.textContent = c; });

    var showV = v >= 1, showC = c >= 1;
    if (!showV && !showC) { el.style.display = 'none'; return; }
    el.style.display = '';
    viewSlides.forEach(function (s) { s.style.display = showV ? '' : 'none'; });
    cartSlides.forEach(function (s) { s.style.display = showC ? '' : 'none'; });
    // Tek metrik kaldıysa kaydırma animasyonunu durdur (boş kare olmasın)
    if (showV && showC) el.classList.remove('tm-cu--single');
    else el.classList.add('tm-cu--single');
  }

  function fillBadges() {
    var ids = collectIds();
    if (!ids.length) return;

    // Cache kontrolü
    var cache = {};
    try { cache = JSON.parse(sessionStorage.getItem('tm_sp_counts') || '{}'); } catch (_) {}
    var now = Date.now();
    var missing = ids.filter(function (id) {
      return !cache[id] || (now - cache[id]._at > COUNTS_CACHE_MS);
    });

    function render() {
      document.querySelectorAll('conversion-urgency[data-product-id]').forEach(function (el) {
        var id = el.getAttribute('data-product-id');
        var d = cache[id];
        if (d) applyCounts(el, d.v | 0, d.c | 0);
      });
      document.querySelectorAll('[data-tm-sp][data-product-id]').forEach(function (el) {
        var id = el.getAttribute('data-product-id');
        var d = cache[id];
        if (d) applyChip(el, d.v | 0, d.c | 0);
      });
    }

    if (!missing.length) { render(); return; }

    var url = ENDPOINT + (ENDPOINT.indexOf('?') > -1 ? '&' : '?') +
      'action=counts&ids=' + encodeURIComponent(missing.join(','));
    fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (res) {
        if (res && res.data) {
          Object.keys(res.data).forEach(function (id) {
            var d = res.data[id] || {};
            cache[id] = { v: d.v | 0, c: d.c | 0, s: d.s | 0, _at: now };
          });
          try { sessionStorage.setItem('tm_sp_counts', JSON.stringify(cache)); } catch (_) {}
        }
        render();
      })
      .catch(function () { render(); });
  }

  // --- Ürün sayfası: view logla + ATC yakala ---
  function initProductPage() {
    var pid = (window.tmProduct && window.tmProduct.id) ? window.tmProduct.id : null;
    if (pid) logViewOncePerWindow(pid);

    // ATC: pub/sub (mobil) — cartData.product_id öncelikli
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
          var id = (e && e.cartData && e.cartData.product_id) || pid;
          logAtc(id);
        });
      } catch (_) {}
    }
    // ATC: buton tıklaması (masaüstü yönlendirmesi öncesi de yakalar)
    if (pid) {
      document.addEventListener('click', function (ev) {
        var btn = ev.target.closest && ev.target.closest('.product-form__submit, [name="add"]');
        if (btn) logAtc(pid);
      }, true);
    }
  }

  function init() {
    initProductPage();
    fillBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Sonsuz kaydırma / filtre sonrası yeni kartları doldur
  document.addEventListener('collection:reloaded', fillBadges);
})();
